/**
 * API client for the Momentum activity chart.
 *
 * Request plumbing (session cookie, JSON parsing, error shape) lives in
 * httpClient.ts — see that module for the error convention.
 */
import { getJson, ErrorResponse } from './httpClient';

/** Daily counts of meaningful tree changes for the given tree, over the trailing `days` window. */
export async function getProjectActivity(projectId: string, ostId: string, days = 30): Promise<unknown | ErrorResponse> {
    return getJson(`/api/projects/${projectId}/osts/${ostId}/activity?days=${days}`);
}
